import { render, staticRenderFns } from "./RemarkUnitsDialog.vue?vue&type=template&id=a565c112&scoped=true"
import script from "./RemarkUnitsDialog.vue?vue&type=script&lang=js"
export * from "./RemarkUnitsDialog.vue?vue&type=script&lang=js"
import style0 from "./RemarkUnitsDialog.vue?vue&type=style&index=0&id=a565c112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a565c112",
  null
  
)

export default component.exports